import React, { Component, PropTypes } from 'react'
import { HashRouter as Router, Route,Switch } from 'react-router-dom'
import Home from '../../containers/pc-day/Home-hy.jsx'
import Login from '../../containers/pc-day/Login-hy.jsx'
import LotterySSC from '../../containers/pc-day/lotterys/Ssc.jsx'
import PTGameHall from '../../containers/pc-day/PTGameHall.jsx'
import AgGameHall from '../../containers/pc-day/AgGameHall.jsx'
import Casino from '../../containers/pc-day/Casino.jsx'
import Sports from '../../containers/pc-day/Sports.jsx'
import Slot from '../../containers/pc-day/Slot.jsx'
import Test from '../../_test/_testContainer.jsx'
import Report from '../../containers/pc-day/Report.jsx'
import Activity from '../../containers/pc-day/Activity.jsx'
import Frame from '../../containers/pc-day/FrameContainer.jsx'
import BBINGameHall from '../../containers/pc-day/BBINGameHall-hy.jsx'
import ChangePassword from "../../containers/pc-day/ChangePassword.jsx"
import Chess from '../../containers/pc-day/Chess.jsx'
export default class Routes extends Component {

    render() {
        return (
            <Router>
                <div>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/login" component={Login}/>
                    <Route exact path="/lottery/:template/:lotteryFlag/:methodType" component={LotterySSC} />
                    <Route exact path="/game/pt/:type" component={PTGameHall} />
                    <Route exact path="/game/ag/:type" component={AgGameHall} />
                    <Route exact path="/game/bbin/:type" component={BBINGameHall} />
                    <Route exact path="/casino" component={Casino} />
                    <Route exact path="/casino/:platform" component={Casino} />
                    <Route exact path="/slot" component={Slot} />
                    <Route exact path="/slot/:platform" component={Slot} />
                    <Route exact path="/sports" component={Sports} />
                    <Route exact path="/activity/:id" component={Activity} />
                    <Route exact path="/frame/:add" component={Frame} />
	                <Route exact path="/report/:type/:name/:childname" component={Report} />
                    <Route exact path="/report/:type/:name" component={Report} />
                    <Route exact path="/my/:type" component={ChangePassword} />
                    <Route exact path="/chess" component={Chess} />
                    {
                        process.env.NODE_ENV === 'dev' ? <Route path="/test" component={Test} /> : null
                    }
                </div>
            </Router>
        )
    }
}
